module.exports = __webpack_public_path__ + "static/img/rank_56.b050e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_56.png
// module id = Edh6
// module chunks = 0